"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoChat/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _opentokreact = require('opentok-react');


var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _log = require('shared/log');
var _user = require('shared/selectors/user');

var _hooks = require('web/services/hooks');
var _VideoSettingsModal = require('./VideoSettingsModal'); var _VideoSettingsModal2 = _interopRequireDefault(_VideoSettingsModal);
var _Spinner = require('../Spinner'); var _Spinner2 = _interopRequireDefault(_Spinner);
var _detectrtc = require('detectrtc'); var _detectrtc2 = _interopRequireDefault(_detectrtc);
var _errors = require('shared/errors');
var _AnonymousPage = require('web/components/AnonymousPage');

const missingPermissionsError = "Missing Permissions"

/* The /join_video_chat response (apps/backend/webserver/video_server.go videoInfo). */

















function hasPermissions () {
  return new Promise(resolve => {
    _detectrtc2.default.load(() => {
      const hasMic = _detectrtc2.default.isWebsiteHasMicrophonePermissions
      const hasVideo = _detectrtc2.default.isWebsiteHasWebcamPermissions
      resolve({ hasMic, hasVideo })
    })
  })
}

const reconnectAction = { label: 'Reconnect', onClick: () => location.reload() }
const Hangup = () => (
  _react2.default.createElement(_AnonymousPage.PageWrapper, { className: "video-chat--error-page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
    , _react2.default.createElement(_AnonymousPage.ActionResult, {
      title: "Success",
      subtitle: "You successfully disconnected from your video chat."      ,
      action: reconnectAction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
    )
  )
)

const BadKeyError = () => (
  _react2.default.createElement(_AnonymousPage.PageWrapper, { className: "video-chat--error-page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
    , _react2.default.createElement(_AnonymousPage.ActionResult, {
      title: "404",
      subtitle: 
        _react2.default.createElement(_react2.default.Fragment, null, "Sorry, this link doesn't seem to lead anywhere..."

          , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 64}} ), "Please try another link or contact us at "
                  , ' '
          , _react2.default.createElement('a', { href: "mailto:support@bloomtext.com", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, "support@bloomtext.com")
        )
      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
    )
  )
)

const PermissionError = () => (
  _react2.default.createElement(_AnonymousPage.PageWrapper, { className: "video-chat--error-page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
    , _react2.default.createElement(_AnonymousPage.ActionResult, {
      title: "Permissions required" ,
      subtitle: 
        _react2.default.createElement(_react2.default.Fragment, null, "Sorry, we don't have permission to use your camera and microphone. Please update your browser permissions."

          , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}} ), "Contact us at "
             , _react2.default.createElement('a', { href: "mailto:support@bloomtext.com", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}, "support@bloomtext.com"), ' ', "or call our support line "
               , _react2.default.createElement('a', { href: "tel:+14159031200", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}, "(415) 903-1200" ), " if you have any questions."
        )
      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
    )
  )
)






const VideoChat = ({ videoKey, userKey }) => {
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)

  const [connection, setConnection] = _react.useState(null)
  const [streams, setStreams] = _react.useState([])
  const [video, setVideo] = _react.useState.call(void 0, true)
  const [audio, setAudio] = _react.useState.call(void 0, true)
  const [badKey, setBadKey] = _react.useState.call(void 0, false)
  const [hangup, setHangup] = _react.useState.call(void 0, false)
  const [currentCamera, setCurrentCamera] = _react.useState.call(void 0, 0)
  const [currentMic, setCurrentMic] = _react.useState.call(void 0, 0)
  const [availableCameras, setAvailableCameras] = _react.useState([])
  const [availableMics, setAvailableMics] = _react.useState([])
  const [settingsOpen, setSettingsOpen] = _react.useState.call(void 0, false)
  const [finishedLoadingDevices, setFinishedLoadingDevices] = _react.useState.call(void 0, false)
  const [permissionsDenied, setPermissionsDenied] = _react.useState.call(void 0, false)

  // Was the class's `sessionHelper` instance field; the unmount cleanup and
  // hangup read it. Render reads the copy in `connection` instead.
  const sessionHelperRef = _react.useRef(undefined)
  const topRef = _react.useRef(null)

  const getDevices = _react.useCallback.call(void 0, () => {
    hasPermissions().then(() => {
      OT.getDevices((error, devices) => {
        if (error) {
          // SAFETY: log.error handles non-Error values at runtime; the value is passed through unchanged.
          _log.log.error(error )
          return
        }

        const videoIds = []
        const audioIds = []
        devices.forEach((d) => {
          // The default one is listed twice, so just skip it
          if (d.deviceId === 'default') {
            return
          }

          if (d.kind === 'videoInput') {
            videoIds.push({
              id: d.deviceId,
              name: d.label,
            })
          } else if (d.kind === 'audioInput') {
            audioIds.push({
              id: d.deviceId,
              name: d.label,
            })
          }
        })
        setAvailableCameras(videoIds)
        setAvailableMics(audioIds)
        setFinishedLoadingDevices(true)
      })
    })
  }, [])

  // componentDidMount / componentWillUnmount. Mount-only on purpose: the route
  // component is reused when only the video key in the URL changes, and the
  // class never rejoined in that case either.
  _react.useEffect.call(void 0, () => {
    let TokBoxSessionId = ''
    let TokBoxApiKey = ''
    let TokBoxToken = ''

    // SAFETY: the key is only sent to the backend, which validates it.
    _client2.default.joinVideoChat(videoKey, (currentUser.UserKey || userKey || '') )
      // SAFETY: joinVideoChat is untyped; this is the backend's videoInfo shape.
      .then((res) => {
        TokBoxSessionId = res.TokBoxSessionId
        TokBoxApiKey = res.TokBoxApiKey
        TokBoxToken = res.TokBoxToken
        return _opentokreact.createSession.call(void 0, {
          apiKey: TokBoxApiKey,
          sessionId: TokBoxSessionId,
          token: TokBoxToken,
          // createSession passes the same, mutated array on every update, so
          // copy it: the class's setState re-rendered even for the same array.
          // SAFETY: see OTStream; opentok.js streams have `id` at runtime.
          onStreamsUpdated: (s) => setStreams([...s] ),
        })
      })
      .then((result) => {
        sessionHelperRef.current = result
        setConnection({
          apiKey: TokBoxApiKey,
          sessionId: TokBoxSessionId,
          token: TokBoxToken,
          sessionHelper: result,
        })
      })
      .catch((e) => {
        if (e === missingPermissionsError) { // TODO where is this error thrown?
          return
        }
        if (e instanceof _errors.RestError && !e.response.ServerError) {
          setBadKey(true)
          return
        }
        // SAFETY: log.error handles non-Error values at runtime; the value is passed through unchanged.
        _log.log.error(e )
      })

    getDevices()

    return () => {
      // Kept from the class: this throws when no session was created (for
      // example when leaving the 404 page for a bad key). Listed as a follow-up.
      sessionHelperRef.current.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onHangup = _react.useCallback.call(void 0, () => {
    sessionHelperRef.current.disconnect()
    setHangup(true)
  }, [])

  const changeAudio = _react.useCallback.call(void 0, (idx) => {
    setCurrentMic(idx)
    setFinishedLoadingDevices(false)
    getDevices()
  }, [getDevices])

  const changeVideo = _react.useCallback.call(void 0, (idx) => {
    setCurrentCamera(idx)
    setFinishedLoadingDevices(false)
    getDevices()
  }, [getDevices])

  const swapCamera = () => {
    let nextCamera = currentCamera + 1
    if (nextCamera >= availableCameras.length) {
      nextCamera = 0
    }
    changeVideo(nextCamera)
  }

  const showSettings = () => setSettingsOpen(true)
  const closeSettings = _react.useCallback.call(void 0, () => setSettingsOpen(false), [])
  const toggleAudio = () => setAudio(a => !a)
  const toggleVideo = () => setVideo(v => !v)

  const onPublishedError = (err) => {
    if (err.name.indexOf("ACCESS_DENIED") > -1) {
      setPermissionsDenied(true)
    }
    _log.log.info("Published error", err)
  }

  if (permissionsDenied) {
    return _react2.default.createElement(PermissionError, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 246}})
  }

  if (badKey) {
    return _react2.default.createElement(BadKeyError, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 250}} )
  }

  if (hangup) {
    return _react2.default.createElement(Hangup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 254}} )
  }

  if (!connection || !connection.sessionId || !connection.apiKey || !connection.token || !finishedLoadingDevices) {
    return null
  }

  const { session } = connection.sessionHelper

  let subscribers = (
    _react2.default.createElement('div', { className: "video-chat--loading-message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
      , _react2.default.createElement(_Spinner2.default, { color: "#fff", __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}), " Waiting for other user to join"

    )
  )

  const numSubs = streams.length
  if (numSubs > 0) {
    // Just support 1:1 chat for now
    if (numSubs === 1) {
      const stream = streams[0]
      subscribers = _react2.default.createElement(_opentokreact.OTSubscriber, { key: stream.id, session: session, stream: stream, properties: {
        width: '100%',
        height: '100%',
        showControls: false,
      }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}})
    } else {
      let h = 1
      let w = 0
      // Reads the container from the previous commit, as the class did.
      const top = topRef.current
      if (top) {
        h = top.clientHeight
        w = top.clientWidth
      }

      let subWidth = '100vw'
      let subHeight = '100vh'
      // Taller than high
      if (h > w) {
        subHeight = Math.floor(100 / numSubs) + 'vh'
      } else {
        subWidth = Math.floor(100 / numSubs) + 'vw'
      }

      subscribers = (
        _react2.default.createElement('div', { className: "video-chat-subscriber-container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}}
          ,  streams.map(stream => (
            _react2.default.createElement(_opentokreact.OTSubscriber, { key: stream.id, session: session, stream: stream, properties: {
              width: subWidth,
              height: subHeight,
              showControls: false,
            }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}})
          )) 
        )
      )
    }
  }

  const publishedProps = {
    showControls: false,
    width: '120px',
    height: '150px',
  }

  // Kept from the class: an out-of-range device index throws here.
  if (availableCameras.length > 0 && video) {
    publishedProps.publishVideo = true
    publishedProps.videoSource = availableCameras[currentCamera].id
  } else {
    publishedProps.publishVideo = false
  }

  if (availableMics.length > 0 && audio) {
    publishedProps.publishAudio = true
    publishedProps.audioSource = availableMics[currentMic].id
  } else {
    publishedProps.publishAudio = false
  }

  const publisherComponent = (
    _react2.default.createElement(_opentokreact.OTPublisher, {
       session: session,
       properties: publishedProps,
       onError: onPublishedError, __self: this, __source: {fileName: _jsxFileName, lineNumber: 335}})
  )

  return (
    _react2.default.createElement('div', { className: "video-chat", ref: topRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 342}}
      , _react2.default.createElement(_VideoSettingsModal2.default, { open: settingsOpen,
                          onClose: closeSettings,
                          cameras: availableCameras,
                          mics: availableMics,
                          currentCamera: currentCamera,
                          currentMic: currentMic,
                          onChangeVideo: changeVideo,
                          onChangeAudio: changeAudio, __self: this, __source: {fileName: _jsxFileName, lineNumber: 343}} )
      , _react2.default.createElement('div', { className: "video-chat-controls-top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 351}}
        , _react2.default.createElement('div', { className: 'video-chat-controls--swap-camera ' + (availableCameras.length > 1 ? '' : 'disabled'), onClick: swapCamera, __self: this, __source: {fileName: _jsxFileName, lineNumber: 352}}
          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 353}}, "swap_horiz")
        )
        , _react2.default.createElement('div', { className: "video-chat-controls--settings", onClick: showSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 355}}
          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 356}}, "settings")
        )
      )
      ,  subscribers 
      ,  publisherComponent 
      , _react2.default.createElement('div', { className: "video-chat-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 361}}
        , _react2.default.createElement('div', { className: 'video-chat-controls--audio ' + (audio ? '' : 'disabled'), onClick: toggleAudio, __self: this, __source: {fileName: _jsxFileName, lineNumber: 362}}
          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 363}}, "mic")
        )
        , _react2.default.createElement('div', { className: 'video-chat-controls--end-call', onClick: onHangup, __self: this, __source: {fileName: _jsxFileName, lineNumber: 365}}
          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 366}}, "call_end")
        )
        , _react2.default.createElement('div', { className: 'video-chat-controls--video ' + (video ? '' : 'disabled'), onClick: toggleVideo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 368}}
          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 369}}, "videocam")
        )
      )
    )
  )
}

/* SAFETY: opentok-react types preloadScript as taking and returning a component
 * with no props. At runtime it forwards every prop except opentokClientUrl and
 * loadingDelegate, so the wrapped component's props are kept. */
const withOpenTokScript = (Inner) =>
  _opentokreact.preloadScript.call(void 0, Inner ) 

/* Was connect(mapState)(preloadScript(VideoChat)). memo stands in for
 * connect's shallow prop check on the outside; the store read moved into
 * VideoChat as useAppSelector. */
exports. default = _react.memo.call(void 0, withOpenTokScript(VideoChat))
